import { useEffect } from 'react';

/*eslint-disable */
export default function useAsync(fn, deps) {
  useEffect(() => {
    fn();
  }, deps);
}
/*eslint-enable */
